/**
 * Feature previews — who sees a new version of a screen early.
 * `/me` is the caller's own list; the admin routes manage the lists.
 */
import { apiDelete, apiGet, apiPost } from '../client.js';

export const fetchMyFeaturePreviews = () => apiGet('/api/feature-previews/me');
export const fetchFeaturePreviews = () => apiGet('/api/admin/feature-previews');
export const grantFeaturePreview = (featureId, user) =>
  apiPost(`/api/admin/feature-previews/${encodeURIComponent(featureId)}/users`, { body: user });
export const revokeFeaturePreview = (featureId, userId) =>
  apiDelete(`/api/admin/feature-previews/${encodeURIComponent(featureId)}/users/${encodeURIComponent(userId)}`);
